import { createStore } from "vuex";
import main from "./main";
import sideMenu from "./side-menu";
import userAuth from "./user-auth";
import userInfo from "./user-info";
import householdFilter from "./module/household-filter";
import familyFilter from "./module/family-filter";
import memberFilter from "./module/member-filter";
import volunteerFilter from "./module/volunteer-filter";
import reportFilter from "./module/report-filter";
import reportProblemFilter from "./module/report-problem-filter";
import reportProblemDimensionFilter from "./module/report-problem-dimension-filter";
import reportCMFilter from "./module/report-cm-filter";
import reportProblemTarget from "./module/report-problem-target-filter";
import pivotTableFilter from "./module/pivot-table-filter";
import newsFilter from "./module/news-filter";
import usersFilter from "./module/users-filter";
import hcmUserFilter from "./module/hcm-users-filter";
import mainFilterSearch from "./module/main-filter-search";
import exportBtnClick from "./module/landingpage-export-file";

const store = createStore({
  modules: {
    main,
    sideMenu,
    userAuth,
    userInfo,
    householdFilter,
    familyFilter,
    memberFilter,
    volunteerFilter,
    reportFilter,
    reportProblemFilter,
    reportProblemDimensionFilter,
    reportCMFilter,
    reportProblemTarget,
    pivotTableFilter,
    newsFilter,
    usersFilter,
    hcmUserFilter,
    mainFilterSearch,
    exportBtnClick
  },
});

export function useStore() {
  return store;
}

export default store;
